module.exports = __webpack_public_path__ + "img/Banner1.c2760338.png";